import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class UwTranslationService {

  constructor(private _translateService: TranslateService) { }

  translateWithParams(translationKey: string, translationParams?: {[key: string]: string}) {
    let resolvedTranslationParams: {[key: string]: string} = {};

    //resolve translation for translationParams
    if (translationParams) {
      Object.keys(translationParams).forEach(key => {
        const value = translationParams[key];

        const translatedValue = this._translateService.instant(value);
        resolvedTranslationParams[key] = translatedValue;
      });
    }

    return this._translateService.instant(translationKey, resolvedTranslationParams);
  }

  tranlsateErrorMessage(errorCode: string): string {
    const translated = this._translateService.instant(errorCode);
    if (translated !== errorCode) {
      return translated;
    }
    const prefixed = this._translateService.instant(
      `messages.error.${errorCode}`,
    );

    return prefixed === `messages.error.${errorCode}` ? errorCode : prefixed;
  }
}
